const BRAND_COLORS = ["#0F9648", "#11C675", "#ECF4EF", "#F59E0B"];

export async function celebrate(): Promise<void> {
	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		return;
	}
	try {
		const { default: confetti } = await import("canvas-confetti");
		await confetti({
			particleCount: 120,
			spread: 75,
			origin: { y: 0.3 },
			colors: BRAND_COLORS,
			disableForReducedMotion: true,
		});
	} catch {
		// Confetti is decorative — a failed chunk load must never surface.
	}
}
